// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indi-app .indi-status-message-wrapper {
    position: absolute;
    top: 15px;
    width: 100%;
    display: flex;
    left: 0;
    justify-content: center;
}

.indi-app .indi-status-message {
    min-width: 350px;
}

/* .indi-app .indi-status-message-wrapper.indi-alert-show { */
.indi-app .indi-status-message-wrapper {
    opacity: 1;
    transition: all 250ms linear;
    z-index: 99999;
}

.indi-app .indi-status-message-wrapper.indi-alert-hide {
    opacity: 0;
    transition: all 250ms linear;
    z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/components/controls/alerts/alert.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,OAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,UAAU;IACV,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,WAAW;AACf","sourcesContent":[".indi-app .indi-status-message-wrapper {\n    position: absolute;\n    top: 15px;\n    width: 100%;\n    display: flex;\n    left: 0;\n    justify-content: center;\n}\n\n.indi-app .indi-status-message {\n    min-width: 350px;\n}\n\n/* .indi-app .indi-status-message-wrapper.indi-alert-show { */\n.indi-app .indi-status-message-wrapper {\n    opacity: 1;\n    transition: all 250ms linear;\n    z-index: 99999;\n}\n\n.indi-app .indi-status-message-wrapper.indi-alert-hide {\n    opacity: 0;\n    transition: all 250ms linear;\n    z-index: -1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
